import { calcRem } from 'component-library/__styling/style-functions'
import styled from '@emotion/styled'
import { FillProperty } from 'csstype'

export interface CameraProps {
    className?: string
    width?: number
    height?: number
    horizontalSpacing?: number | undefined
    fill?: FillProperty
}

export const StyledCameraIcon = styled('svg')<CameraProps>(props => ({
    width: props.width ? calcRem(props.width) : undefined,
    height: props.height ? calcRem(props.height) : undefined,
    marginLeft: props.horizontalSpacing && calcRem(props.horizontalSpacing),
    fill: props.fill as FillProperty,
}))
